import url from '../url'
import headers from '../headers'

export default {
	get (context) {
		return context.$http.get(
			`${url}/user`,
			headers.bearer()
		)
	},
	getByUid (context, user_uid) {
		return context.$http.get(
			`${url}/users/${user_uid}`,
			headers.bearer()
		)
	},
	edit (context, user_uid, model) {
		return context.$http.put(
			`${url}/users/${user_uid}`,
			// model:
			// fullname
			// picture (uid)
			model,
			headers.bearer()
		)
	},
	getPermittedUsers (context, user_uid, size = 999) {
		return context.$http.get(
			`${url}/users/${user_uid}/permissions/users/?size=${size}`,
			headers.bearer()
		)
	},
	notifications: {
		setDevice (context, user_uid, model) {
			return context.$http.post(
				`${url}/users/${user_uid}/notifications/`,
				model,
				headers.bearer()
			)
		},
		setDeviceActive (context, user_uid, model) {
			return context.$http.post(
				`${url}/users/${user_uid}/notifications/active/`,
				model,
				headers.bearer()
			)
		},
		setDeviceDesactive (context, user_uid, model) {
			return context.$http.post(
				`${url}/users/${user_uid}/notifications/desactive/`,
				model,
				headers.bearer()
			)
		},
		getDevices (context, user_uid, size = 999) {
			return context.$http.get(
				`${url}/users/${user_uid}/notifications/?size=${size}`,
				headers.bearer()
			)
		}
	},
	password: {
		edit (context, user_uid, model) {
			return context.$http.put(
				`${url}/users/${user_uid}/password`,
				model,
				headers.bearer()
			)
		}
	},
	email: {
		edit (context, user_uid, model) {
			return context.$http.put(
				`${url}/users/${user_uid}/email`,
				model,
				headers.bearer()
			)
		}
	},
	watches: {
		add (context, user_uid, model) {
			return context.$http.post(
				`${url}/users/${user_uid}/watches`,
				model,
				headers.bearer()
			)
		}
	},
	admin: {
		getAll (context, offset = 0, size = 999) {
			return context.$http.get(
				`${url}/users/?offset=${offset}&size=${size}`,
				headers.bearer()
			)
		},
		get (context, user_uid) {
			return context.$http.get(
				`${url}/users/${user_uid}`,
				headers.bearer()
			)
		}
	}
}



// WEBPACK FOOTER //
// ./src/api/modules/users.js